import React from 'react';
import { string, oneOf } from 'prop-types';
import cx from 'classnames';

import './../../assets/icons/close.svg';

const propTypes = {
  alt: string,
  name: string,
  size: oneOf(['small', 'medium', 'large', 'xlarge']),
};

const CLASS_ROOT = 'icon';

const Icon = ({ className, name, size, alt, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
      [`${CLASS_ROOT}--${name}`]: name,
    },
    className
  );

  /** temporary solution for Button component needs */
  return (
    <svg
      className={classes}
      role={alt ? 'img' : 'presentation'}
      {...(alt ? { 'aria-label': alt } : { 'aria-hidden': 'true' })}
      {...other}
    >
      <use xlinkHref={`/sprite.svg#${name}`} />
    </svg>
  );
};

Icon.displayName = 'Icon';
Icon.propTypes = propTypes;

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js